import { Component, OnInit } from "@angular/core";
import { AnimationOptions } from "ngx-lottie";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "app-processing-placeholder",
  templateUrl: "./processing-placeholder.component.html",
  styleUrls: ["./processing-placeholder.component.scss"],
  standalone: false
})
export class ProcessingPlaceholderComponent implements OnInit {
  public customOptions: OwlOptions = {
    mouseDrag: true,
    margin: 0,
    responsive: {
      0: {
        items: 1
      }
    }
  };

  public lottieConfig: AnimationOptions = {
    path: "../../../assets/anim/anim_OCR.json",
    autoplay: true,
    loop: true
  };

  constructor() {}

  ngOnInit() {}
}
